// extracted by mini-css-extract-plugin
export default {"wrap":"Cr-z","logoContainer":"Dr-z","brandImg":"Er-z","logoImg":"Fr-z","logoButton":"Gr-z"};